import m from "./../../../dist/es2015/locales/en_CA.js";
export const am5locales_en_CA = m;